import type { ErrorList } from "@/api/BasicResponseInterface";

export class LoginError {
    public readonly errors: ErrorList;

    constructor(errors: ErrorList) {
        this.errors = errors;
    }
}
